import { FlatList, VStack, View } from "@gluestack-ui/themed";
import { SelectProductsListProps } from "@repo/core/components/layout/SelectProductsList/types";
import { ProductListTile } from "@repo/core/screens/Proposals/components/ProductListTile";
import { Text } from "@repo/core/components/core/Text";

export const SelectProductsList = ({
  products,
  selectedProduct,
  onSelectProduct
}: SelectProductsListProps) => {
  return (
    <VStack flex={1} w="$full" gap="$6">
      <Text
        fontSize="$md"
        fontWeight={400}
        fontFamily="inter"
        color="$textLight800"
      >
        Selecione o produto desejado:
      </Text>
      <VStack gap="$4" flex={1}>
        <FlatList
          data={products}
          flex={1}
          gap="$4"
          ItemSeparatorComponent={() => <View height="$3" />}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          keyExtractor={(item: any) => item.id}
          // Glustack not accept type of renderItem
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          renderItem={({ item }: any) => (
            <ProductListTile
              {...item}
              isActive={item.id === selectedProduct}
              onPress={onSelectProduct}
            />
          )}
        />
      </VStack>
    </VStack>
  );
};
